export const textFilterHandler = (filter, fieldName, value) => {
  if (value === '') {
    delete filter.current[fieldName]
    return
  }
  filter.current[fieldName] = { ilike: `%${value}%` }
}
